import { TrashIcon } from '@heroicons/react/24/outline';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from 'components/layout/popover';

type StructureSwitcherProps = {
  label: string;
  options: { label: string; value: string }[];
  selectedUniqueId: string | null;
  onSelect: (uniqueId: string) => void;
  onDeactivate: (uniqueId: string, label: string) => void;
};

const labelClassName = 'whitespace-nowrap text-neutral-300';

export default function StructureSwitcher({
  label,
  options,
  selectedUniqueId,
  onSelect,
  onDeactivate
}: StructureSwitcherProps) {
  const hasOtherStructures = options.some(
    (option) => option.value !== selectedUniqueId
  );

  if (!hasOtherStructures) {
    return <span className={labelClassName}>{label}</span>;
  }

  return (
    <Popover hoverEnabled placement='bottom-start'>
      <PopoverTrigger asChild>
        <button
          type='button'
          className={`${labelClassName} cursor-pointer group-hover:text-white`}
        >
          {label}
        </button>
      </PopoverTrigger>
      <PopoverContent className='z-50 min-w-[180px] rounded-md bg-neutral-800 py-1 shadow-lg'>
        {options.map((option) => (
          <div
            key={option.value}
            className='flex items-center hover:bg-neutral-700'
          >
            <button
              type='button'
              className={`grow cursor-pointer px-3 py-1.5 text-left text-xs ${
                option.value === selectedUniqueId
                  ? 'font-semibold text-white'
                  : 'text-neutral-300'
              }`}
              onClick={() => onSelect(option.value)}
            >
              {option.label}
            </button>
            {option.value !== selectedUniqueId && (
              <button
                type='button'
                aria-label={`Delete ${option.label}`}
                className='cursor-pointer px-2 py-1.5 text-neutral-500 hover:text-red-400'
                onClick={(e) => {
                  e.stopPropagation();
                  onDeactivate(option.value, option.label);
                }}
              >
                <TrashIcon className='h-3.5 w-3.5' />
              </button>
            )}
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
}
